import React from 'react';
import { Auth, Hub } from 'aws-amplify';
import { MainHeader, Button } from 'sharedComponents';
import { BackArrow } from 'sharedComponents/Icons';
import { Typography, Box, Icon, IconButton } from '@material-ui/core';
import { logoutUrl } from 'constants/index';

export const SunsetPage = ({ classes, config, isTestUser, overrideSunset }) => {
  const onSignOut = () => {
    const authConfig = config.get('Auth');
    Hub.dispatch('osp-auth', { signOut: true });
    Auth.signOut();
    window.location.href = logoutUrl(authConfig);
  };

  const renderTitle = () => (
    <Box className={classes.headerContainer}>
      <Box className={classes.headerTitle}>
        <IconButton
          edge="start"
          color="inherit"
          aria-label="go back"
          data-testid="go-back"
          onClick={onSignOut}
          classes={{ root: classes.icon }}
        >
          <Icon component={BackArrow} fontSize="small" />
        </IconButton>
      </Box>
    </Box>
  );

  return (
    <>
      <MainHeader customTitle={renderTitle} />
      <Box className={classes.container}>
        <Box className={classes.typography}>
          <Typography variant="h1" className={classes.text}>
            You can no longer access Connect in the browser.
          </Typography>
          <Typography variant="body1">Please login to Connect 2.0 native app to continue using Connect.</Typography>
        </Box>
        <Box className={classes.buttonContainer}>
          {isTestUser && (
            <Button className={classes.button} onClick={overrideSunset}>
              TEST USER: Click to Override
            </Button>
          )}
        </Box>
      </Box>
    </>
  );
};

export default SunsetPage;
